import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {Col, Container, FormControl, Row} from "react-bootstrap";

import {
	useDebouncedEffect,
	useEffectPromise,
} from "../../../Hooks/EffectHooks";
import {
	useCheckAuth,
	useGetQueryStringParameter
} from "../../../Hooks/RouteHooks";
import {useClassNames} from "../../../Hooks/StyleHooks";

import {
	useBenefitValues,
	useFilteredBenefits,
	useFilteredBenefitValues,
} from "../../../Hooks/BenefitHooks";
import {LedgerTable} from "./LedgerTable";
import {service as ContextNodeService} from "../../../Services/ContextNodeService";
import {service as ConfirmationStatusService} from "../../../Services/ConfirmationStatusService";
import {ConfirmationStatusEditor} from "../../../Models/Core/ServiceDrivenEditors";
import {PreConfirmationStatusHelpIcon} from "../../Common/BenefitSummary/PreConfirmationStatusHelpIcon";


export const LedgerPage = (props) => {
	useCheckAuth();
	
	const classNames = useClassNames('sb-ledger-page');
	const context = useSelector(state => state.contextState.context);
	const contextNodeId = context?.contextNodeId;
	
	const getQueryStringParameter = useGetQueryStringParameter();
	const confirmationStatusIdFromUrl = getQueryStringParameter('confirmationStatusId', 2);
	
	const [contextNode, setContextNode] = useState(null);
	const [confirmationStatusId, setConfirmationStatusId] = useState(confirmationStatusIdFromUrl);
	const [benefitValues, reloadBenefitValues] = useBenefitValues(contextNodeId, 3, true);
	const filteredBenefitValues = useFilteredBenefitValues(benefitValues, confirmationStatusId)
	const environmentalBenefits = useFilteredBenefits(filteredBenefitValues, null);
	
	const [textFilter, setTextFilter] = useState('');
	const confirmationStatus = ConfirmationStatusService?.CachedValueById(confirmationStatusId)?.result;
	const lastChanged = props.lastChanged ?? null;
	
	useEffect(() => {
		reloadBenefitValues();
	}, [contextNodeId, lastChanged]);
	
	useDebouncedEffect(() => {
		
	}, [textFilter]);
	
	const addToSearch = (text) => {
		if (textFilter === '') {
			setTextFilter(text);
		} else if (textFilter === text) {
			setTextFilter('');
		} else if (!textFilter.includes(text)) {
			setTextFilter(`${textFilter} ${text}`);
		}
	};
	
	const clearSearch = () => {
		if (textFilter !== '') {
			setTextFilter('');
		}
	};
	
	
	useEffectPromise(
		async () => {
			if(contextNodeId == null) {
				return null;
			}
			return (await ContextNodeService.Get(contextNodeId))?.result ?? {};
		},
		(contextNode) => {
			setContextNode(contextNode);
		},
		[contextNodeId],
		true
	);
	
	
	return <Container className={classNames}>
		<Row>
			<Col xs={12} md={12}>
				<h2 className="atomic-sectionheader">
					{contextNode ? `${contextNode?.name} ${confirmationStatus?.name ?? ''} Benefits` : 'Loading...'}
					<PreConfirmationStatusHelpIcon confirmationStatusCode={confirmationStatus?.code}/>
				</h2>
			</Col>
		</Row>
		<Row>
			<Col xs={4} md={4}></Col>
			<Col xs={4} md={4}>
				<div className="float-right bottom10" style={{ width: '215px' }}>
					<FormControl
						style={{width: '100%'}}
						type="text"
						autoCorrect="off"
						autoCapitalize="off"
						autoComplete="off"
						spellCheck={false}
						value={textFilter}
						placeholder="Search Project or Funder"
						onChange={(x) => setTextFilter(x.target.value)}
					/>
				</div>
			</Col>
			<Col xs={4} md={4}>
				<ConfirmationStatusEditor
					Value={confirmationStatusId}
					OnUpdate={setConfirmationStatusId}
				/>
			</Col>
		</Row>
		<Row>
			<Col xs={12} md={12}>
				<LedgerTable
					className="fixed"
					benefitValues={filteredBenefitValues}
					environmentalBenefits={environmentalBenefits}
					totalContextNodeId={contextNodeId}
					textFilter={textFilter}
					reloadData={reloadBenefitValues}
					AddToSearch={addToSearch}
					HasFilters={textFilter !== ''}
					ClearFilters={clearSearch}
				/>
			</Col>
		</Row>
	</Container>
};
